import { useEffect } from 'react'

import { bodyScrollLock } from './bodyScrollLock'

/**
 * Locks the body scroll while the component is mounted (and `enabled`), through the shared counted
 * lock of `bodyScrollLock.js`. `className` is added to the body for as long as at least one caller
 * asks for it (the organizer overlays use `org-drawer-open` to hide the Crisp button).
 */
export default function useBodyScrollLock({ className, enabled = true } = {}) {
    useEffect(() => {
        if (!enabled) return undefined
        bodyScrollLock.lock({ className })
        return () => bodyScrollLock.unlock({ className })
    }, [className, enabled])
}
